module.exports = __webpack_public_path__ + "static/media/incline_bench-01.258ab111.png";